import { Box, Typography} from '@mui/material';

export const AttributeItem = ({ label, value, highlight = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
    <Typography variant="subtitle1" color="text.secondary" sx={{ minWidth: '120px' }}>
        {label}
    </Typography>
    <Typography 
      variant="subtitle1" 
      fontWeight='bold'
      color={highlight ? 'error.main' : 'text.primary'}
    >
        {value}
    </Typography>
  </Box>
);

